export enum RideRequirementType {
  Wheelchair = 1,
  Stretcher = 2,
  Lift = 3,
}
